// Swahili — top-level translations. Falls back to English for missing keys.
import en from "./en";

const sw = {
  ...en,
  ui: {
    ...en.ui,
    brand: "My World Quest",
    brand_subtitle: "Paka Rangi na Jifunze",
    nav: {
      home: "Nyumbani", countries: "Nchi", globe: "Dunia", continents: "Mabara",
      color: "Rangi", puzzles: "Mafumbo", games: "Michezo", math: "Hisabati ya Jiografia",
      quiz: "Maswali", parents: "Wazazi", more: "Zaidi",
     "geo-lines": "Mistari ya dunia", "maths-academy": "Akademia ya Hesabu",},
    accessibility: { bigText: "Maandishi Makubwa", highContrast: "Tofauti Kubwa" },
    navGroups: { quick: "Haraka", explore: "Chunguza", play: "Cheza na Jifunze", collect: "Kusanya", adv: "Tukio", grownup: "Kwa wakubwa" },
    actions: { back: "Rudi", close: "Funga", reset: "Anza Upya", save: "Hifadhi", retry: "Jaribu Tena", playAgain: "Cheza Tena" },
  },
  microcopy: {
    ...en.microcopy,
    great: "Kazi nzuri! ⭐",
    correct: "✅ Sawa!",
    nope: "Jaribu tena!",
    tryAgain: "Karibu! Endelea!",
    awesome: "Vizuri sana!",
    welcome: "Karibu {{country}}! Tujifunze {{language}}.",
    youDidIt: "Umefanikiwa!",
    perfect: "BORA SANA!",
  },
  home: {
    ...en.home,
    title1: "Chunguza Dunia",
    title2: "Nchi Moja kwa Wakati Mmoja",
    subtitle: "Matukio ya kijiografia ya kufurahisha, maswali, changamoto, na zawadi zinazosaidia watoto kugundua nchi, tamaduni, bendera, alama maarufu, na zaidi.",
    playNow: "Cheza Sasa →",
    takeQuiz: "Fanya Maswali",
    openGlobe: "Fungua Dunia Kubwa →",
    globeHint: "Bonyeza alama inayong'aa kujifunza nchi!",
    popularCountries: "Au bonyeza bendera",
    whatNext: "Unataka kufanya nini leo?",
    whatNextSub: "Chagua chochote — yote ni furaha!",
    tiles: {
      ...en.home.tiles,
      learn: "Jifunze Nchi", learnDesc: "Nchi 30+ na bendera!",
      globe: "Dunia 3D", globeDesc: "Zungusha na bonyeza",
      continents: "Mabara", continentsDesc: "Chunguza mabara 7",
      color: "Paka Alama Maarufu", colorDesc: "Paka Mnara wa Eiffel!",
      math: "Hisabati ya Jiografia", mathDesc: "Jumlisha km, hesabu nchi!",
      quiz: "Wakati wa Maswali", quizDesc: "Rahisi na ngumu",
      parents: "Kwa Wazazi", parentsDesc: "Ona maendeleo",
    },
  },
  learn: {
    title: "Jifunze Nchi", capital: "Mji mkuu", language: "Lugha", hello: "Habari",
    learnIt: "Nimejifunza!", listen: "Sikiliza",
    goalsEyebrow: "Malengo ya Kujifunza ya Leo",
    goalsHeading: "🎯 Anza na haya kwanza",
    goalsSubtitle: "Mambo manne muhimu zaidi kujifunza ukiwa na miaka {{tier}} — yamechaguliwa kutoka mtaala.",
    goalsAllTopics: "Ona mada zote",
    goalsLearnNow: "Jifunze sasa",
    goalsKey: "Msingi #{{n}}",
    topicTitles: {
      "art-design": "Kuchora, Rangi na Ubunifu",
      "music": "Muziki: Mdundo, Wimbo na Nukuu",
      "computing-code": "Programu, Algoriti na Usalama Mtandaoni",
      "physical-education": "Michezo, Afya na Mazoezi",
      "world-religions": "Dini na Imani za Dunia",
      "wellbeing-relationships": "Afya, Hisia na Urafiki",
    },
  },
  globe: {
    title: "Dunia 3D", subtitle: "Zungusha na bonyeza",
    learnLang: "Jifunze lugha", moreInfo: "Maelezo zaidi", learnedTag: "✓ Imejifunzwa",
    spinTap: "Zungusha dunia na bonyeza nchi!", spinTapSub: "Bonyeza alama ujue zaidi.",
  },
  quiz: {
    title: "Maswali", basic: "Rahisi", advanced: "Ngumu",
    start: "Anza Maswali", next: "Endelea →", finish: "Mwisho!", score: "Alama",
  },
  stickers: { title: "Albamu yangu ya Stika", subtitle: "Kusanya stika kutoka kila mchezo!" },
  langSwitcher: {
    label: "Lugha",
    english: "English", french: "Français", hindi: "हिन्दी", arabic: "العربية",
    italian: "Italiano", spanish: "Español", mandarin: "中文", japanese: "日本語", korean: "한국어", swahili: "Kiswahili",
  },
  common: {
    whereToNext: "Twende wapi baadaye?",
    home: "Nyumbani",
    earnMoreStars: "⭐ Pata nyota zaidi",
    earnHowTo: "Cheza mchezo wa haraka — kila moja inakupa XP!",
    pickAge: "Chagua umri",
    ages: "Umri",
    startExploring: "Anza kuchunguza",
    pickAnywhere: "Chagua hapo juu — au bofya!",
    tapAnyCountry: "Gusa nchi yoyote ujifunze hadithi yake!",
    exploreGlobe: "Chunguza Dunia",
    exploreGlobeSub: "Tukio la 3D la skrini nzima",
  },
  shortcuts: {
    home: "Nyumbani",
    continents: "Mabara",
    globe: "Dunia",
    ask: "Uliza",
    landmarks: "Alama maarufu",
    flags: "Bendera",
    pixel: "Pixel",
    puzzles: "Vitendawili",
    math: "Hesabu",
    trip: "Safari",
    quiz: "Maswali",
    quests: "Misheni",
    stickers: "Vibandiko",
    miniGames: "Michezo midogo",
    geoMath: "Hesabu za jiografia",
    quickQuiz: "Maswali ya haraka",
    myTrophies: "Tuzo zangu",
    colorCreate: "Paka rangi & Tengeneza",
    spinGlobe: "Zungusha tufe",
    askGlobe: "Uliza tufe",
    dreamTrip: "Safari ya Ndoto",
    earnStars: "Pata nyota",
    tryAQuest: "Jaribu misheni",
    playAgain: "Cheza tena",
    learnCountry: "Jifunze nchi",
    colorLandmark: "Paka rangi alama",
    learnCountries: "Jifunze Nchi",
    advanced: "Hali ya Juu",
    spellCountry: "Andika nchi",
    advancedHub: "Eneo la kina",
    squishyHop: "Squishy Hop",
    mathSnap: "Math Snap",
    language: "Lugha",
    geoLines: "Mistari ya dunia",
  },
  coloringExtra: {
    modeLandmarks: "Alama maarufu",
    modeFlags: "Msanii wa Bendera",
    modePixel: "Sanaa ya Pixel",
    diffEasy: "Rahisi",
    diffMedium: "Wastani",
    diffExpert: "Mtaalam",
    difficultyLabel: "Ugumu:",
  },
  tilesExtra: {
    labelLearn: "Jifunze",
    labelCreate: "Tengeneza",
    labelPlay: "Cheza",
    labelTrophies: "Vikombe",
    whatNextSub: "Chagua chochote — vyote ni vya kufurahisha!",
  },
  pills: {
    orTry: "Au jaribu ↓",
    
    squishyHop: "Squishy Hop",
    mathSnap: "Snap ya Hesabu",colorLandmark: "Paka rangi alama maarufu",
    solvePuzzle: "Suluhisha kitendawili",
    dreamTrip: "Panga safari ya ndoto",
    geoMath: "Jaribu hesabu za jiografia",
    continentQuests: "Misheni za mabara",
    stickerBook: "Albamu ya vibandiko",
    famousPeople: "Kutana na watu maarufu",
    culturalSpot: "Eneo la kitamaduni",
    quickQuiz: "Maswali ya haraka",
    continentMaps: "Ramani za mabara",
    spellCountry: "Andika nchi",
    flagArtist: "Msanii wa bendera",
    pixelArt: "Sanaa ya pikseli",
    spinGlobe: "Zungusha tufe",
    askGlobe: "Uliza tufe",
    myTrophies: "Tuzo zangu",
    advancedHub: "Eneo la kina",
    geoLines: "Mistari ya dunia",
  },
  canvas: {
    tools: "Zana",
    brushSize: "Ukubwa wa brashi",
    colors: "Rangi",
    patterns: "Mifano",
    modes: "Hali",
    solid: "Imara",
    anyColor: "Rangi nyingine",
    recent: "Hivi karibuni",
    sticker: "Kibandiko",
    symmetry: "Ulinganifu",
    colorByNumber: "Paka rangi kwa nambari",
    reference: "Marejeleo",
    undo: "Rudi",
    redo: "Rudisha",
    reset: "Anza upya",
    replay: "Cheza tena",
    check: "Angalia",
    save: "Hifadhi",
    fill: "Jaza",
    pencil: "Penseli",
    stamp: "Muhuri",
    erase: "Futa",
    on: "ON",
    off: "OFF",
    tool: "Zana:",
    pattern: "mfano:",
    printOne: "Chapisha hii",
    downloadAll: "Pakua zote",
    appTitle: "Paka Rangi & Tengeneza 🎨",
    appSub: "Brashi, mifano, vibandiko, paka rangi kwa nambari na zaidi!",
  },
};

export default sw;
